<div class="owners">
    <div class="header" *ngIf="label">
        <span class="label">{{ label }}</span>
    </div>
    <div class="adder" *ngIf="isEditable">
        <app-dropdown-autocomplete
            [formControl]="ownerControl"
            [items]="users"
            valueField="id"
            displayField="name"
            [appendTo]="'body'"
            [emptyText]="placeholder"
            (selectItem)="onOwnerSelected($event)">
        </app-dropdown-autocomplete>
    </div>
    <div class="chips">
        <ng-container *ngIf="owners?.length; else emptyState">
            <div class="chip" *ngFor="let owner of owners">
                <span class="name">{{ displayName(owner) }}</span>
                <button *ngIf="isEditable"
                        class="remove"
                        type="button"
                        (click)="removeOwner(owner)"
                        aria-label="Remove owner">
                    <i class="material-icons">close</i>
                </button>
            </div>
        </ng-container>
        <ng-template #emptyState>
            <div class="empty">{{ emptyText }}</div>
        </ng-template>
    </div>
</div>
